import { render } from "./PlanDetail.vue?vue&type=template&id=644bc054&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./PlanDetail.vue?vue&type=style&index=1&id=644bc054&lang=css"
import "./PlanDetail.vue?vue&type=style&index=2&id=644bc054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644bc054"]])

export default __exports__